import React from "react";
import { CardElement } from "@stripe/react-stripe-js";
import { Input } from "@repo/ui";
import BackButton from "../../../../components/BackButton";
import { withTranslations } from "../../../../hoc/withTranslations/withTranslations";
import { useTranslation } from "react-i18next";

const LOCALE = "modules_Guests_pages_GuestPaymentPage_PaymentForm";

interface PaymentFormProps {
  email: string;
  name: string;
  errorMessage: string | null;
  setEmail: (value: string) => void;
  setName: (value: string) => void;
  setCardComplete: (complete: boolean) => void;
  handleSubmit: (e?: React.FormEvent) => Promise<void>;
  onBackClick: () => void;
}

const PaymentForm: React.FC<PaymentFormProps> = ({
  email,
  name,
  errorMessage,
  setEmail,
  setName,
  setCardComplete,
  handleSubmit,
  onBackClick,
}) => {
  const { t } = useTranslation(LOCALE);

  return (
    <div className="flex-1 mb-8 md:mb-0 md:mr-8 p-8">
      <BackButton text={t("back_to_summary")} onClick={onBackClick} />
      <h2 className="text-2xl font-bold mb-4">{t("payment_method")}</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label className="block text-gray-700 font-semibold mb-2">
            {t("email")}
          </label>
          <Input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("email_placeholder")}
            className="w-full"
            type="email"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-semibold mb-2">
            {t("full_name")}
          </label>
          <Input
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t("full_name_placeholder")}
            className="w-full"
          />
        </div>

        <div className="mt-4">
          <label className="block text-gray-700 font-semibold mb-2">
            {t("card_number")}
          </label>
          <div className="p-4 border rounded-md">
            <CardElement onChange={(e) => setCardComplete(e.complete)} />
          </div>
        </div>

        {errorMessage && <p className="text-red-500 mt-4">{errorMessage}</p>}
      </form>
    </div>
  );
};

export default withTranslations(LOCALE)(PaymentForm);
